import {
	SHOW_LOADING,
	GET_NAME_SPACE,
	LOAD_NAME_SPACE,
	UPDATE_NAME_SPACE,
	GET_TEMPLATES,
	SAVE_TEMPLATE,
	CREATE_TEMPLATE,
	GET_BRAND_STYLE,
	PUT_BRAND_STYLE,
	SAVE_BRAND_STYLE,
	SAVE_WHATSAPP_ADMIN_NUMBERS,
	GET_WHATSAPP_ADMIN_NUMBERS,
	POST_WHATSAPP_ADMIN_NUMBERS,
	SYNC_TEMPLATES,
	GET_CHANNEL_WHATSAPP_NUMBERS,
	SAVE_CHANNEL_WHATSAPP_NUMBERS,
	SEND_WHATSAPP_MESSENGER_SETTINGS,
	SAVE_WHATSAPP_MESSENGER_SETTINGS,
	GET_WHATSAPP_MESSENGER_SETTINGS,
	RESET_CHANNELS,
	BRAND_STYLE_UPDATING,
	GET_WHATSAPP_NUMBER_METRICS,
	SAVE_WHATSAPP_NUMBER_METRICS,
	DELETE_TEMPLATE,
	GET_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS,
	SAVE_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS
} from "../constants/channel";

export const getNamespace = () => {
	return {
		type: GET_NAME_SPACE,
	};
};
export const saveNamespace = (nameSpace) => {
	return {
		type: LOAD_NAME_SPACE,
		payload: nameSpace,
	};
};
export const updateNamespace = (nameSpace) => {
	return {
		type: UPDATE_NAME_SPACE,
		payload: nameSpace,
	};
};

export const showLoading = () => {
	return {
		type: SHOW_LOADING,
	};
};

export const getTemplates = () => {
	return {
		type: GET_TEMPLATES,
	};
};

export const saveTemplate = (template) => {
	return {
		type: SAVE_TEMPLATE,
		payload: template,
	};
};

export const createTemplate = (template) => {
	return {
		type: CREATE_TEMPLATE,
		payload: template,
	};
};

export const deleteTemplate = (name) => {
	return {
		type: DELETE_TEMPLATE,
		payload: { name },
	};
};

export const getBrandStyle = () => {
	return {
		type: GET_BRAND_STYLE,
	};
};

export const updateBrandStyle = (id, data) => {
	return {
		type: PUT_BRAND_STYLE,
		payload: { id, data },
	};
};

export const resetChannels = () => {
	return {
		type: RESET_CHANNELS,
	}
}

export const saveBrandStyle = (data) => {
	return {
		type: SAVE_BRAND_STYLE,
		payload: data,
	};
};

export const getWhatsappNumberAdmin = () => {
	return {
		type: GET_WHATSAPP_ADMIN_NUMBERS,
	};
};

export const saveWhatsappNumberAdmin = (data) => {
	return {
		type: SAVE_WHATSAPP_ADMIN_NUMBERS,
		payload: data,
	};
};

export const postWhatsappNumberAdmin = (data) => {
	return {
		type: POST_WHATSAPP_ADMIN_NUMBERS,
		payload: data,
	};
};

export const syncTemplates = () => {
	return {
		type: SYNC_TEMPLATES,
	};
};

export const getChannelWhatsappNumbers = () => {
	return {
		type: GET_CHANNEL_WHATSAPP_NUMBERS,
	};
};
export const saveChannelWhatsappNumbers = (whatsappNumbers) => {
	return {
		type: SAVE_CHANNEL_WHATSAPP_NUMBERS,
		payload: whatsappNumbers,
	};
};

export const sendWhatsappMessengerSettings = ({ settings, whatsappNumber }) => {
	return {
		type: SEND_WHATSAPP_MESSENGER_SETTINGS,
		payload: { settings, whatsappNumber },
	};
};

export const saveWhatsappMessengerSettings = (settings) => {
	return {
		type: SAVE_WHATSAPP_MESSENGER_SETTINGS,
		payload: settings,
	};
};

export const getWhatsappMessengerSettings = (whatsappNumber) => {
	return {
		type: GET_WHATSAPP_MESSENGER_SETTINGS,
		payload: whatsappNumber,
	};
};

export const isBrandStyleUpdating = (updating) => {
	return {
		type: BRAND_STYLE_UPDATING,
		payload: updating,
	};
};

export const getWhatsappNumberMetrics = (number) => {
	return {
		type: GET_WHATSAPP_NUMBER_METRICS,
		payload: number
	}
}

export const saveWhatsappNumberMetrics = (data) => {
	return {
		type: SAVE_WHATSAPP_NUMBER_METRICS,
		payload: data
	}
}

export const getWhatsappNumberConversationAnalyitcs = (query) => {
	return {
		type: GET_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS,
		payload: query
	}
}

export const saveWhatsappNumberConversationAnalyitcs = (data) => {
	return {
		type: SAVE_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS,
		payload: data
	}
}
